<div class="col-12-nav">
    <div class="signin-header">
        <div class="container">
            <section class="logo center-block-wrap">
                <div class="logo-white"></div>
            </section>
        </div>
    </div>
    <div class="col-12 img-bg pl-5 pr-5">
        <div class="text-right mt-1">
            <a tabindex="0" id="en" class="btn btn-default border border-left-0 border-top-0 border-bottom-0 border-dark rounded-0" (click)="functionsService.useLanguage('en')">EN <span class="sr-only">Change language to English</span></a>
            <a tabindex="0" id="es" class="btn btn-default" (click)="functionsService.useLanguage('es')">ES <span class="sr-only">Cambiar idioma a español</span></a>
        </div>
        <h3>{{'accessibility-policy.title' | translate}}</h3>
        <br>
        <!-- <span class="dark-gray-text"><strong>Panic Alert</strong></span> -->
        <br><br>
        <p>{{'accessibility-policy.paragraph1' | translate}}</p>
        <p innerHTML="{{'accessibility-policy.paragraph2' | translate}}"></p>
        <p innerHTML="{{'accessibility-policy.paragraph3' | translate}}"></p>
        <div class="p-4 text-center font-small">©2025 Contigo MSJ. {{'general.all_rights' | translate}}</div>
    </div>
</div>
